import { echartSetOption, tooltipFormatter } from './echarts-utils';

/* -------------------------------------------------------------------------- */
/*                             Echarts Total Sales                            */
/* -------------------------------------------------------------------------- */

const zeroBurnOutChartInit = () => {
  const { getColor, getData, getPastDates } = window.phoenix.utils;
  const $zeroBurnOutChartEl = document.querySelector(
    '.echart-zero-burnout-chart'
  );

  if ($zeroBurnOutChartEl) {
    const userOptions = getData($zeroBurnOutChartEl, 'echarts');
    const chart = window.echarts.init($zeroBurnOutChartEl);

    const getDefaultOptions = () => ({
      tooltip: {
        trigger: 'axis',
        backgroundColor: getColor('background-color-default'),
        borderColor: getColor('background-color-muted'),
        formatter: params => tooltipFormatter(params, 'MMM DD, YYYY'),
        axisPointer: {
          shadowStyle: {
            color: 'red'
          }
        },
        extraCssText: 'z-index: 1000'
      },
      legend: {
        bottom: '10',
        data: [
          {
            name: 'Open',
            icon: 'roundRect'
          },
          {
            name: 'Issues found',
            icon: 'roundRect'
          },
          {
            name: 'In Progress',
            icon: 'roundRect'
          }
        ],
        itemWidth: 16,
        itemHeight: 8,
        itemGap: 10,
        inactiveColor: getColor('text-color-soft'),
        inactiveBorderWidth: 0,
        textStyle: {
          color: getColor('text-color-default'),
          fontWeight: 600,
          fontSize: 16,
          fontFamily: 'Nunito Sans'
        }
      },

      xAxis: [
        {
          show: true,
          interval: 2,
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: getColor('border-color-default')
            }
          },
          axisLabel: {
            color: getColor('text-color-default'),
            formatter: data => window.dayjs(data).format('D MMM'),
            interval: 5,
            align: 'left',
            margin: 20,
            fontSize: 12.8
          },
          axisTick: {
            show: true,
            length: 15
            // alignWithLabel: true
          },
          splitLine: {
            interval: 0,
            show: true,
            lineStyle: {
              color: getColor('border-color-default'),
              type: 'dashed'
            }
          },
          type: 'category',
          boundaryGap: false,
          data: getPastDates(15)
        },
        {
          show: true,
          interval: 2,
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            interval: 1,
            show: true,
            lineStyle: {
              color: getColor('border-color-default'),
              type: 'solid'
            }
          },
          boundaryGap: false,
          data: getPastDates(15)
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        axisLine: {
          lineStyle: {
            type: 'solid',
            color: getColor('border-color-default')
          }
        },
        axisLabel: {
          color: getColor('text-color-default'),
          margin: 20,
          fontSize: 12.8,
          interval: 0
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: getColor('border-color-default'),
            type: 'solid'
          }
        },
        axisTick: {
          show: true,
          length: 15,
          alignWithLabel: true,
          lineStyle: {
            color: getColor('border-color-default')
          }
        }
      },
      series: [
        {
          name: 'Estimated',
          type: 'line',
          symbol: 'none',
          data: [20, 17.5, 15, 15, 15, 12.5, 10, 7.5, 5, 2.5, 2.5, 2.5, 0],
          lineStyle: {
            width: 0
          },
          areaStyle: {
            color: getColor('color-primary-light'),
            opacity: 0.075
          },
          tooltip: {
            show: false
          }
        },
        {
          name: 'Issues found',
          type: 'line',
          symbolSize: 6,
          itemStyle: {
            color: getColor('background-color-subtle'),
            borderColor: getColor('color-success'),
            borderWidth: 2
          },
          lineStyle: {
            color: getColor('color-success')
          },
          symbol: 'circle',
          data: [3, 1, 2, 4, 3, 1]
        },
        {
          name: 'Open',
          type: 'line',
          symbolSize: 6,
          itemStyle: {
            color: getColor('background-color-subtle'),
            borderColor: getColor('color-info'),
            borderWidth: 2
          },
          lineStyle: {
            color: getColor('color-info')
          },
          symbol: 'circle',
          data: [6, 5, 4, 6, 5, 5]
        },
        {
          name: 'In Progress',
          type: 'line',
          symbolSize: 6,
          itemStyle: {
            color: getColor('background-color-subtle'),
            borderColor: getColor('color-warning'),
            borderWidth: 2
          },
          lineStyle: {
            color: getColor('color-warning')
          },
          symbol: 'circle',
          data: [11, 12, 11, 9, 11, 6]
        },
        {
          name: 'Actual',
          type: 'line',
          symbolSize: 6,
          itemStyle: {
            color: getColor('background-color-subtle'),
            borderColor: getColor('text-color-soft'),
            borderWidth: 2
          },
          lineStyle: {
            color: getColor('text-color-soft'),
            type: 'dashed'
          },
          symbol: 'circle',
          data: [20, 19, 15, 14, 12, 8]
        }
      ],
      grid: {
        right: 5,
        left: -1,
        bottom: '15%',
        top: 13,
        outerBoundsMode: 'same',
        outerBoundsContain: 'axisLabel'
      }
    });

    echartSetOption(chart, userOptions, getDefaultOptions);
  }
};

export default zeroBurnOutChartInit;
